//import { Link } from "react-router-dom";

//Third party
import { FcDocument } from "react-icons/fc";
import { GiShipWheel } from "react-icons/gi";

// Internal
import { useContext } from "react";
import { CustomStepper, DisplayStatus } from "../../../components";
import { GlobalContextData } from "../../../context";
import "./DraftTopHeader.scss";
import { Button, Chip } from "@mui/material";
import { DOC_STATUS } from "../../../Constants";
import moment from "moment";
import { GlobalService } from "../../../shared/globalService";
import { generatePdf } from "../../../shared/pdfService";

export const DraftTopHeader = () => {
  const { state } = useContext(GlobalContextData);

  const downloadPdf = async () => {
    try {
      const publishedOn =
        moment(new Date()).format("DD MMM YYYY HH:mm A") || "";
      const docTitle = `[DRAFT] - ${state.documentInfo.shipName || ""}` || "";
      const docVersion = state.documentInfo.version + "";

      if (!GlobalService.getDocHtml) {
        alert("Something went wrong! Please refresh the page and try again");
        return;
      }
      const html = await GlobalService.getDocHtml();

      await generatePdf(html, {
        version: docVersion,
        title: docTitle,
        publishedOn,
      });
    } catch (err) {
      console.error("Error in download pdf", err);
    }
  };

  return (
    <div className="draft-Top-Header ">
      <div className="left-draft-section">
        <span>
          <FcDocument className="fc-doc" />
        </span>
        <div className="doc-with-status">
          <span className="doc-name">{state.documentInfo.name || ""}</span>
          {state.documentInfo.name !== "" &&
            state.documentInfo.status === DOC_STATUS.DRAFT && (
              <DisplayStatus status={"Draft"} />
            )}
        </div>
      </div>

      {state.documentInfo.shipName && (
        <Button
          className="download-button"
          size="small"
          variant="outlined"
          style={{ maxHeight: "40px", marginTop: 16, marginLeft: 8 }}
          onClick={downloadPdf}
        >
          Download
        </Button>
      )}

      <div className="center-draft-section ">
        <CustomStepper />
      </div>
      {state.documentInfo.shipName && (
        <div
          className="right-draft-section"
          style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
        >
          <Chip
            key={"lastModified"}
            className="chip-gap"
            icon={<GiShipWheel className="ship-icon " />}
            label={state.documentInfo.shipName || ""}
            variant="outlined"
          />
          <p style={{ fontSize: "12px", marginTop: 4 }}>
            version: {state.documentInfo.revisionVersion}
          </p>
        </div>
      )}
    </div>
  );
};
